import './Microguide.css';
export var animatedContent = '_z4mh733-3-8-0';
export var contentWrapper = '_z4mh732-3-8-0';
export var footer = '_z4mh734-3-8-0';
export var stepContainer = '_z4mh730-3-8-0';
export var visualWrapper = '_z4mh731-3-8-0';
export var wrapper = '_z4mh735-3-8-0';
export var wrapperPosition = {'bottom-left':'_z4mh736-3-8-0','top-right':'_z4mh737-3-8-0','top-left':'_z4mh738-3-8-0','bottom-right':'_z4mh739-3-8-0'};